<div *ngIf="dataToShow">
  <h3>Einspeisermanagement</h3>

  <section>
    <h4>{{ dataToShow.title }}</h4>
    <div [innerHtml]="dataToShow.titleDescription || ''"></div>
  </section>

  <section>
    <h4>{{ dataToShow.optionTitle }}</h4>
    <div [innerHtml]="dataToShow.optionDescription || ''"></div>
  </section>

  <section *ngIf="dataToShow.price">
    <h4>Preis inkl. Mwst: {{ dataToShow.price | germanCurrency }}</h4>
    {{ dataToShow.priceDescription }}
    <br />
    Preis exkl. Mwst: {{ dataToShow.price / (1 + this.MwSt / 100) | germanCurrency }}
  </section>

  <section *ngIf="!!dataToShow.confirmationBody && showConfirmationBody">
    <div [innerHtml]="dataToShow.confirmationBody | safeHtmlPipe"></div>
  </section>
</div>
